export default "__VITE_ASSET__7a5d8070__"